import { motion } from 'framer-motion';

import TeamMemberItem, { type TeamMember } from './TeamMemberItem';

const AdvisorsSection = () => {
  const advisors: TeamMember[] = [
    {
      id: 4,
      name: 'Lilli Marmurek, MSW RSW',
      role: 'Chief Experience Officer',
      bio: 'Registered Social Worker | Relationship Specialist | Life Strategist\nLilli Marmurek is the Chief Experience Officer at konnect better, where she helps individuals, couples, and families strengthen their relationships through workshops, coaching, and digital resources. With over a decade of experience, she specializes in topics like parent-child relationships, co-parenting through divorce, healing from trauma and betrayal, reconnecting after parenthood, and balancing marriage with career. Outside of her work, she is a proud mother of two, wife, and sports enthusiast, committed to wellness, family, and helping others thrive in all aspects of life.',
      image: '/images/lilli_marmurek.png',
      social: {
        linkedin:
          'https://www.linkedin.com/in/lilli-marmurek-msw-rsw-58659b47/',
      },
    },
  ];

  return (
    <section id="advisors" className="section bg-surface dark:bg-panel/95">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16">
          {/* Left Section: Title and Subtitle */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-4 lg:sticky lg:top-24 lg:self-start"
          >
            <div className="lg:pr-8">
              <h2 className="text-3xl md:text-4xl font-bold text-primary dark:text-theme-primary mb-4">
                our advisors
              </h2>
              <div className="w-24 h-1 bg-secondary mb-6"></div>
              <p className="text-lg text-theme-secondary">
                Experts who helped us grow. We're grateful for the brilliant
                minds who have shaped our journey.
              </p>
            </div>
          </motion.div>

          {/* Right Section: Advisors */}
          <div className="lg:col-span-8">
            {advisors.map((advisor, index) => (
              <motion.div
                key={advisor.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <TeamMemberItem member={advisor} />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdvisorsSection;
